enum JobWorkerNotInterestedReason {
	Undefined           = 0,
	NotLooking          = 1,
	Salary              = 2,
	Location            = 3,
	Position            = 4,
}

export default JobWorkerNotInterestedReason;